// Generated types for ActionUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionUsageReadAPI extends SysMLUsageReadAPI {
}

export interface ActionUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionUsageReadAPISchema: z.ZodType<ActionUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const ActionUsageWriteAPISchema: z.ZodType<ActionUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
